import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import useTheme from 'src/customizations/themes/hooks/useTheme';
const BtnShell = ({ size = 'sm', iconName, ...btnProps }) => {
    const [{ theme }] = useTheme();
    return (React.createElement(Button, { variant: "text", size: size, ...btnProps }, ({ textStyle }) => (React.createElement(FeatherIcon, { name: iconName, style: textStyle, size: theme.iconSize[size] }))));
};
export const PrevBtn = ({ ...btnProps }) => {
    return (React.createElement(BtnShell, { iconName: "rewind", ...btnProps }));
};
export const StopBtn = ({ ...btnProps }) => {
    return (React.createElement(BtnShell, { iconName: "square", ...btnProps }));
};
export const PauseBtn = ({ ...btnProps }) => {
    return (React.createElement(BtnShell, { iconName: "pause", ...btnProps }));
};
export const ResumeBtn = ({ ...btnProps }) => {
    return (React.createElement(BtnShell, { iconName: "play", ...btnProps }));
};
export const NextBtn = ({ ...btnProps }) => {
    return (React.createElement(BtnShell, { iconName: "fast-forward", ...btnProps }));
};
export const LinkBtn = ({ ...btnProps }) => {
    return (React.createElement(BtnShell, { iconName: "external-link", ...btnProps }));
};
export const MoreBtn = ({ ...btnProps }) => {
    return (React.createElement(BtnShell, { iconName: "more-vertical", ...btnProps }));
};
